module.exports = "<p>\n  login works!\n</p>\n<button class=\"btn btn-primary\" (click)=\"signIn()\">Sign In</button>"


//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = 1